module.exports = {
    tag: 'blessed',
    quality: 0.7,
    learning: 1,
	perception: 1,
	mana: 1,
	toughness: 1,
	strength: 1,
	willpower: 1,
	dexterity: 1
}